import React from "react";
import PublicLayout from "../../components/layout/PublicLayout";
import BannerDisplay from "./BannerDisplay";
import LibrosDisplay from "./LibrosDisplay";

function Principal(props) {
  return (
    <PublicLayout>
      <BannerDisplay />
      <LibrosDisplay />
    </PublicLayout>
  );
}

export default Principal;
